<template>
	<div class="layout" :class="['layout--' + theme]">
		<slot />
		<Nav :content="$path($store, 'state.Page.item.navContent')" />
		<Footer :content="$path($store, 'state.Page.item.company')" />
		<Cookie />
	</div>
</template>

<script>
import Nav from '@/components/Nav'
import Footer from '@/components/Footer'
import ArrowButton from '@/components/ArrowButton'
import Cookie from '@/components/Cookie'

export default {
	props: {
		theme: {
			type: String,
			default: 'default',
		},
		displayHalf: {
			type: Boolean,
			default: false,
		},
		responsive: {
			type: Boolean,
			default: false,
		},
	},
	components: {
		Nav,
		Footer,
		ArrowButton,
		Cookie,
	},
}
</script>

<style lang="scss">
@import '@/styles/base/_color.scss';
@import '@/styles/base/_variables.scss';
</style>
